// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Chip/common.tsx with go/sail-next-tailor-docs-publisher
import React from 'react';
import {Chip, view} from '@sail/ui';

export const Container = ({children}) => (
  <view.div
    css={{
      background: 'surface',
      paddingX: 'xxlarge',
      paddingY: 'medium',
      borderRadius: 'medium',
    }}
  >
    {children}
  </view.div>
);
export const ChipExample = ({label = 'Status', value = 'Succeeded'}) => {
  return (
    <Chip
      label={label}
      value={value}
      onDropdown={() => {
        // eslint-disable-next-line no-console
        console.log('Dropdown function triggered');
      }}
      onClose={() => {
        // eslint-disable-next-line no-console
        console.log('Close function triggered');
      }}
    />
  );
};
